import React from "react";
import { TableRow, TableCell, Checkbox, IconButton, Collapse, Box } from "@mui/material";
import { Add, Remove } from "@mui/icons-material";

const MemoizedRow = React.memo(
    ({
        row,
        isSelected,
        isCollapsed,
        handleSelect,
        handleCollapse,
        columns,
        collapsible,
        selactable,
        renderActions,
        children,
        rowSx = {},
        RowWrapper
    }) => {

        function get(obj, path, fallback = undefined) {
            return path.split('.').reduce((acc, part) => acc && acc[part], obj) ?? fallback;
        }

        return (
            <>
                <RowWrapper key={row.id} hover sx={rowSx}>
                    {collapsible && (
                        <TableCell padding="">
                            <IconButton size="small" variant="action" onClick={() => handleCollapse(row.id)}>
                                {isCollapsed ? <Remove /> : <Add />}
                            </IconButton>
                        </TableCell>
                    )}

                    {selactable && (
                        <TableCell padding="checkbox">
                            <Checkbox
                                sx={{ mx: 1, my: 0 }}
                                checked={isSelected}
                                onClick={() => handleSelect(row.id)}
                            />
                        </TableCell>
                    )}

                    {columns.map((column, index) => (
                        <TableCell
                            key={`${column.id}-${index}`}
                            sx={{ py: 0.5, px: 2, width: "max-content", whiteSpace: "nowrap" }}
                        >
                            {column.render ? column.render(get(row, column.id), row) : get(row, column.id)}
                        </TableCell>
                    ))}

                    <TableCell align="right" sx={{
                        py: 0.5, px: 2,
                        position: 'sticky',
                        right: 0,
                        zIndex: 1,
                        backgroundColor: rowSx.backgroundColor || "#fff"
                    }}>
                        {renderActions?.(row)}
                    </TableCell>
                </RowWrapper>

                {isCollapsed && (
                    <TableRow>
                        <TableCell
                            colSpan={columns.length + 1 + !!selactable + !!collapsible}
                            sx={{
                                borderBottom: "0 !important",
                                background: "#fdfdfd",
                                paddingBottom: 0,
                                paddingTop: 0,
                            }}
                        >
                            <Collapse in={isCollapsed} timeout="auto" unmountOnExit>
                                {children && (<Box margin={2}>{children}</Box>)}
                            </Collapse>
                        </TableCell>
                    </TableRow>
                )}
            </>
        );
    },
    (prev, next) =>
        prev.isSelected === next.isSelected &&
        prev.isCollapsed === next.isCollapsed &&
        prev.row === next.row // or prev.row.id === next.row.id if rows are immutable
);


export default MemoizedRow;
